import React from 'react';

export const LoadingSpinner = ({ message = 'Loading...' }) => (
  <div className="flex items-center justify-center h-full">
    <div className="text-center space-y-3">
      <div className="w-12 h-12 border-4 border-[#2D3F63]/20 border-t-[#2D3F63] rounded-full animate-spin mx-auto" />
      <p className="text-slate-600">{message}</p>
    </div>
  </div>
);
